type BaseEntity = {
    createdAt: string
    updatedAt: string
    deletedAt: string | null
}

export const OpsUserRole = {
    Admin: 'admin',
    Operator: 'operator',
    Promoter: 'promoter',
} as const

export type OpsUserRole = (typeof OpsUserRole)[keyof typeof OpsUserRole]

export type OpsUser = Partial<BaseEntity> & {
    id: number
    firstName?: string | null
    lastName?: string | null
    nickname?: string | null
    profileUrl?: string | null
    email?: string | null
    userRole?: OpsUserRole
}

export type CreateOpsUserInviteRequest = {
    email: string
    userRole: OpsUserRole
}

export type UpdateOpsUserRequest = {
    id: number
    firstName?: string
    lastName?: string
    nickname?: string
    userRole?: OpsUserRole
}
